import { create } from 'zustand';

import { createAgentSetupPanelSlice } from './actions';
import {
  AgentSetupConversationState,
  AgentSetupDraftState,
  AgentSetupPanelStore,
} from './types';
import { AgentSetupPanelPhase } from '../../enums';

export const useAgentSetupPanelStore = create<AgentSetupPanelStore>()(
  (set, get, store) => ({
    ...createAgentSetupPanelSlice(set, get, store),
  }),
);

export const useAgentSetupPanelPhase = (
  itemId: string,
): AgentSetupPanelPhase | undefined =>
  useAgentSetupPanelStore((state) => state.phaseByItemId[itemId]);

export const useAgentSetupDraft = (
  itemId: string,
): AgentSetupDraftState | undefined =>
  useAgentSetupPanelStore((state) => state.draftByItemId[itemId]);

export const useAgentSetupConversationState = (
  itemId: string,
): AgentSetupConversationState | undefined =>
  useAgentSetupPanelStore((state) => state.conversationByItemId[itemId]);

export const useFinishedAgentSetup = (
  itemId: string,
): AgentSetupDraftState | undefined =>
  useAgentSetupPanelStore((state) => state.finishedByItemId[itemId]);
